/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export enum FullscreenCardIllustrationDTO {
    info = 'info',
    warning = 'warning',
    backup = 'backup',
    photos = 'photos',
    subscriptions = 'subscriptions',
}
